module.exports = " <div class=country v-if=country> <img :src=\"country.en.name | flagImg\"/> {{country[lang].name}} </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Country.vue
 ** module id = 43
 ** module chunks = 1
 **/